import React, { useState } from "react";
import './contact.css';

export default function Form() {
  const [status, setStatus] = useState("idle");

  const handleSubmit = event => {
    event.preventDefault();
    setStatus("sending");

    const form = event.currentTarget;
    const formData = new FormData(form);
    const encodedData = new URLSearchParams();
    formData.forEach((value, key) => encodedData.append(key, value));

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encodedData.toString()
    })
      .then(response => {
        if (!response.ok) throw new Error("Unable to send your message.");
        form.reset();
        setStatus("success");
      })
      .catch(() => setStatus("error"));
  };

  return (
    <form
      name="contact"
      method="post"
      data-netlify="true"
      data-netlify-honeypot="bot-field"
      onSubmit={handleSubmit}
    >
      <input type="hidden" name="form-name" value="contact" />
      <p>
        <label htmlFor="bot-field" className="bot-field">Do not fill this out</label>
        <input className="bot-field" id="bot-field" name="bot-field" tabIndex="-1" autoComplete="off" />
      </p>
      <p>
        <label htmlFor="name">Name</label> <br />
        <input type="text" id="name" name="name" required />
      </p>
      <p>
        <label htmlFor="email">Email</label> <br />
        <input type="email" id="email" name="email" required />
      </p>
      <p>
        <label htmlFor="message">Message</label> <br />
        <textarea id="message" name="message" required rows="8" cols="50"></textarea>
      </p>
      <p>
        <input
          type="submit"
          value={status === "sending" ? "Sending..." : "Send message"}
          disabled={status === "sending"}
        />
      </p>
      {status === "success" && (
        <p className="form-success" role="status">
          Thank you. Your message has been sent successfully.
        </p>
      )}
      {status === "error" && (
        <p className="form-error" role="alert">
          Your message could not be sent. Please try again or use the email link.
        </p>
      )}
    </form>
  );
}


// WEBPACK FOOTER //
// ./src/Form.js